import React from "react";
import { UploadIcon } from "../../Icons";

const UploadButton = () => {
  return (
    <button className='dss-iconbtn upload-btn'>
      <span className='dss-btn-icon'>
        <UploadIcon />
      </span>
    </button>
  );
};

export default UploadButton;
